import React, { useState, useEffect, useRef } from "react";
import "./Pagination.css";

const Pagination = ({
  pageChangeHandler,
  totalRows,
  rowsPerPage,
  currentPage,
  outstandingInvoices,
}) => {
  console.log("🚀 ~ Pagination ~ totalRows:", totalRows)
  const isFirstRender = useRef(true);

  // Calculating max number of pages
  const noOfPages = Math.ceil(totalRows / rowsPerPage);

  // Navigation arrows enable/disable state
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  // These variables give the first and last record/row number
  const [pageFirstRecord, setPageFirstRecord] = useState(1);
  const [pageLastRecord, setPageLastRecord] = useState(rowsPerPage);

  // Onclick handlers for the buttons
  const onNextPage = () => pageChangeHandler(currentPage + 1);
  const onPrevPage = () => pageChangeHandler(currentPage - 1);
  const onPageSelect = (pageNo) => pageChangeHandler(pageNo);

  // Disable previous and next buttons in the first and last page
  useEffect(() => {
    setCanGoNext(currentPage < (noOfPages - 1));
    setCanGoBack(currentPage > 0);
  }, [noOfPages, currentPage, outstandingInvoices]);

  // To set the starting index of the page
  useEffect(() => {
    const skipFactor =
      (currentPage - 1) * rowsPerPage;
    setPageFirstRecord(skipFactor + 1);
  }, [currentPage, rowsPerPage, outstandingInvoices]);

  // To set the last index of the page
  useEffect(() => {
    const count = pageFirstRecord + rowsPerPage;
    setPageLastRecord(count > totalRows ? totalRows : count - 1);
  }, [pageFirstRecord, rowsPerPage, totalRows]);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    if (noOfPages <= 5) {
      // Display all pages
      for (let i = 0; i < noOfPages; i++) {
        pages.push(i + 1);
      }
    } else {
      // Display first 2 pages, current page, and last 2 pages
      // currentPage is 0-based, so convert to 1-based for comparison
      const displayPage = currentPage + 1;
      if (displayPage <= 3) {
        pages.push(1, 2, 3, "...", noOfPages - 1, noOfPages);
      } else if (displayPage >= noOfPages - 1) {
        pages.push(1, 2, "...", noOfPages - 2, noOfPages - 1, noOfPages);
      } else {
        pages.push(
          1,
          "...",
          displayPage - 1,
          displayPage,
          displayPage + 1,
          "...",
          noOfPages
        );
      }
    }
    return pages;
  };

  return (
    <>
      {noOfPages >= 1 ? (
        <div className="flex flex-row gap-[4px] items-center justify-end mb-[30px] w-[1340px]">
          <div className="flex flex-row gap-[4px] float-left items-center justify-end mb-[30px] w-[1000px]">
            {/* First Page Button */}
            <button
              className="h-[21px] w-[21px]"
              onClick={() => pageChangeHandler(0)}
              disabled={currentPage === (0)}
            >
              <img
                src="/images/pagination_fast.958f88a9.svg"
                alt="table pagination fast"
              />
            </button>

            {/* Previous Page Button */}
            <button
              className="h-[21px] w-[21px]"
              onClick={onPrevPage}
              disabled={!canGoBack}
            >
              <img
                src="/images/pagination_slow.52bd7aab.svg"
                alt="table pagination slow"
              />
            </button>

            {/* Page Numbers */}
            {getPageNumbers().map((pageNum, index) => (
              <button
                key={index}
                onClick={() =>
                  typeof pageNum === "number" ? onPageSelect(pageNum - 1) : null
                }
                className={`h-[21px] items-center justify-center pagination_button w-[21px] ${(pageNum - 1) === currentPage ? "clicked text-14px" : ""
                  }`}
                disabled={pageNum === "..."}
              >
                {pageNum}
              </button>
            ))}

            {/* Next Page Button */}
            <button
              className="h-[21px] rotate-180 w-[21px]"
              onClick={onNextPage}
              disabled={!canGoNext}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/images/pagination_slow.52bd7aab.svg"
                alt="table pagination slow"
              />
            </button>

            {/* Last Page Button */}
            <button
              className="h-[21px] rotate-180 w-[21px]"
              onClick={() => pageChangeHandler(noOfPages - 1)}
              disabled={currentPage === noOfPages}
            >
              <img
                src="/images/pagination_fast.958f88a9.svg"
                alt="table pagination fast"
              />
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Pagination;
